import type {Assignee} from '@github-ui/item-picker-assignee-tsq/api/assignee'
import {ConnectionHandler, type RecordSourceProxy} from 'relay-runtime'

export type IssueUpdateArgs = {
  applyAssigneeIds: string[]
  removeAssigneeIds: string[]
}

export function addAssigneesToStore(store: RecordSourceProxy, assignees: Assignee[]) {
  // Create optimistic Assignee records with the provided fields so
  // issues can link to them immediately, as long as they do not yet exist.
  // If they do exist, still copy the values over, as they could be stale.
  for (const assignee of assignees) {
    const record = store.get(assignee.id) || store.create(assignee.id, assignee.__typename)

    const propertiesToSet: Assignee = {
      id: assignee.id,
      login: assignee.login,
      name: assignee.name,
      avatarUrl: assignee.avatarUrl,
      __typename: assignee.__typename,
      isCopilot: assignee.isCopilot,
      profileResourcePath: assignee.profileResourcePath,
    }

    for (const [key, value] of Object.entries(propertiesToSet)) {
      if (value != null) {
        record.setValue(value, key)
      }
    }
  }
}

export function updateIssuesById(
  store: RecordSourceProxy,
  ids: string[],
  existingIssueAssignees: Map<string, string[]>,
  connectionIds: {[key: string]: string[]},
  issueUpdateArgs: IssueUpdateArgs,
) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) return
    const connections = connectionIds[id]?.map(cId => store.get(cId))

    issueUpdateArgs.applyAssigneeIds.map(assigneeId => {
      if (existingIssueAssignees.get(id)?.includes(assigneeId)) return
      const assignee = store.get(assigneeId)
      if (!assignee) return
      connections
        ?.filter(connection => connection)
        .map(connection => {
          const edge = connection && ConnectionHandler.createEdge(store, connection, assignee, 'AssigneeEdge')
          if (edge) ConnectionHandler.insertEdgeBefore(connection, edge)
        })
    })

    issueUpdateArgs.removeAssigneeIds.map(assigneeId => {
      connections
        ?.filter(connection => connection)
        .map(connection => connection && ConnectionHandler.deleteNode(connection, assigneeId))
    })
  }
}
